import React from 'react';
import styled, { css } from 'styled-components/native';
import { calcWidth, calcHeight, isWeb } from '../../../../utils/dimensions';

interface IProps {
  onPress: () => void;
  content: string;
  isActive: boolean;
  style?: any;
  disabled?: boolean;
}

const Controller: React.FC<IProps> = ({ onPress, content, isActive, style, disabled }) => {
  return (
    <S.TouchableOpacity style={style} onPress={onPress} disabled={disabled}>
      <S.Text isActive={isActive}>{content}</S.Text>
    </S.TouchableOpacity>
  );
};

const S = {
  TouchableOpacity: styled.TouchableOpacity`
    justify-content: center;
    align-items: center;
    border-radius: 30px;
    border: ${() => (isWeb ? 'solid 1px #cccccc' : 'none')};
    ${({ theme }) => css`
      background-color: ${theme.colors.white};
      width: ${calcWidth(85)}px;
      height: ${calcHeight(44)}px;
    `}
  `,
  Text: styled.Text<{ isActive: boolean }>`
    ${({ theme, isActive }) => css`
      font-size: ${theme.fontSizes.s14}px;
      color: ${isActive ? theme.colors.primaryBlue : theme.colors.darkPrimary};
      /* font-family: ${isActive ? theme.fontFamilies.GilroyBold : theme.fontFamilies.GilroyMedium}; */
    `}
  `,
};

export default Controller;
